export const GlobalConfig = {
    brushColor: "#010101",
    events: new EventTarget()
  };

  export function setGlobalConfig(key, value) {
    GlobalConfig[key] = value;
    GlobalConfig.events.dispatchEvent(new CustomEvent(key, { detail: value }));
  }
  